export default __webpack_public_path__ + "static/media/DialogInformationMobileImage.e5b742ce.jpg";